import { render } from "./BackgroundRive.vue?vue&type=template&id=12f56e44&scoped=true"
import script from "./BackgroundRive.vue?vue&type=script&lang=js"
export * from "./BackgroundRive.vue?vue&type=script&lang=js"

import "./BackgroundRive.vue?vue&type=style&index=0&id=12f56e44&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f56e44"]])

export default __exports__